import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Lightbulb, ShieldCheck, Download, Zap } from 'lucide-react';
export function Solution() {
  const solutions = ['CÓMO EMPEZAR EN AMAZON DESDE CERO', 'QUÉ PRODUCTOS ELEGIR', 'CÓMO ANALIZAR CORRECTAMENTE', 'CÓMO LANZAR TU PRODUCTO PASO A PASO', 'CÓMO EVITAR ERRORES QUE CUESTAN DINERO'];
  const results = ['ENTENDER CÓMO FUNCIONA AMAZON DESDE CERO', 'SABER EXACTAMENTE QUÉ PRODUCTO ELEGIR', 'EVITAR ERRORES QUE HACEN PERDER DINERO', 'TENER CLARIDAD EN CADA PASO', 'AVANZAR CON SEGURIDAD'];
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white py-24 px-6" data-id="element-410">
      <div className="max-w-6xl mx-auto" data-id="element-411">
        {/* Title */}
        <FadeIn data-id="element-412">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-brand-green mb-6 tracking-wide" data-id="element-413">
            ESTO NO ES SOLO INFORMACIÓN… ES UNA GUÍA PRÁCTICA PARA EMPEZAR
          </h2>
        </FadeIn>

        {/* Supporting text */}
        <FadeIn delay={0.1} data-id="element-414">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-415">
            <p className="text-lg md:text-xl text-brand-text/70 mb-3 font-medium" data-id="element-416">
              Es un sistema paso a paso que te enseña a usar Amazon Seller como
              una herramienta real para generar ingresos desde casa.
            </p>
            <p className="text-lg md:text-xl text-brand-text/70 mb-3" data-id="element-417">
              Vas a aprender cómo funciona la plataforma, cómo ingresar
              productos correctamente, cómo analizar oportunidades reales y cómo
              lanzar con una estructura clara.
            </p>
            <p className="text-lg md:text-xl text-brand-text/70 mb-3" data-id="element-418">
              No es teoría. Es un método práctico pensado para que puedas
              aplicar desde el inicio.
            </p>
            <p className="text-lg md:text-xl text-brand-green font-semibold" data-id="element-419">
              👉 Todo explicado de forma clara para que puedas avanzar sin
              confusión.
            </p>
          </div>
        </FadeIn>

        {/* Two-column layout: content left, image right */}
        <div className="flex flex-col lg:flex-row items-start gap-16 mb-16" data-id="element-420">
          {/* Left column — lists */}
          <div className="flex-1 w-full" data-id="element-421">
            {/* Solutions list */}
            <div className="space-y-4 mb-12" data-id="element-422">
              {solutions.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-423">
                  <div className="flex items-center gap-4 bg-brand-beige/40 p-5 rounded-xl border border-brand-green/5" data-id="element-424">
                    <CheckCircle2 className="w-7 h-7 text-brand-green flex-shrink-0" data-id="element-425" />
                    <p className="text-lg md:text-xl font-semibold text-brand-text" data-id="element-426">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            {/* Results block */}
            <FadeIn delay={0.6} data-id="element-427">
              <div className="mb-12" data-id="element-428">
                <div className="flex items-center gap-3 mb-6" data-id="element-429">
                  <Lightbulb className="w-7 h-7 text-brand-gold" data-id="element-430" />
                  <h3 className="text-2xl md:text-3xl font-bold text-brand-green" data-id="element-431">
                    LO QUE REALMENTE VAS A LOGRAR:
                  </h3>
                </div>
                <div className="space-y-3" data-id="element-432">
                  {results.map((item, index) => <div key={index} className="flex items-center gap-4 pl-2" data-id="element-433">
                      <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0" data-id="element-434" />
                      <p className="text-lg font-medium text-brand-text" data-id="element-435">
                        {item}
                      </p>
                    </div>)}
                </div>
              </div>
            </FadeIn>

            {/* Sin información confusa block */}
            <FadeIn delay={0.7} data-id="element-436">
              <div className="bg-brand-beige rounded-2xl p-8 shadow-sm border border-brand-gold/15" data-id="element-437">
                <p className="text-xl font-semibold text-brand-green mb-4 flex items-center justify-center gap-2" data-id="element-438">
                  <span data-id="element-439">👉</span> SIN INFORMACIÓN CONFUSA
                </p>
                <p className="text-xl font-semibold text-brand-green flex items-center justify-center gap-2" data-id="element-440">
                  <span data-id="element-441">👉</span> SIN PASOS COMPLICADOS
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right column — Image */}
          <div className="flex-shrink-0 w-full lg:w-[38%] lg:sticky lg:top-24" data-id="element-442">
            <FadeIn delay={0.4} data-id="element-443">
              <img src="https://cdn.magicpatterns.com/uploads/k8a1ewWKihihNeRboYEFkL/ChatGPT_Image_7_abr_2026,_06_45_05.png" alt="Mujer trabajando desde casa con laptop, ambiente cálido y productivo" className="w-full h-auto rounded-2xl shadow-lg object-contain" data-id="element-444" />
            </FadeIn>
          </div>
        </div>

        {/* CTA Button */}
        <FadeIn delay={0.8} data-id="element-445">
          <div className="text-center" data-id="element-446">
            <Button onClick={goToCheckout} className="text-lg px-10 py-5" data-id="element-447">
              QUIERO EMPEZAR AHORA
            </Button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-448">
              <span className="flex items-center gap-1.5" data-id="element-449">
                <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-450" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-451">
                <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-452" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-453">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-454" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}